import React, { PureComponent } from 'react';
import { APP_CONFIG } from "../utils/config"

class Privacy extends PureComponent {

  render() {
    let tempStyle = {
      color: '#7F17FE',
      fontSize: '1.0rem',
    }

    return (
        <div><a href={APP_CONFIG.privacyLink} target="_blank" rel="noopener noreferrer" style={tempStyle}>개인정보처리방침</a></div>
    );
  }
};

export default Privacy;